module.exports = __webpack_public_path__ + "static/media/oberflex-freneod728-1200x2490.ec63f0d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-freneod728-1200x2490.jpg
// module id = 1024
// module chunks = 37